// Chakra Imports
import {
  Button,
  Flex,
  Text,
  useColorModeValue,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
// Custom Icons
import { ProfileIcon } from "components/Icons/Icons";
// Custom Components
import { SidebarResponsive } from "components/Sidebar/Sidebar";
import PropTypes from "prop-types";
import React from "react";
import routes from "routes.js";
import { localStore } from "stores/localStore";
import { useHistory } from "react-router-dom";

export default function HeaderLinks(props) {
  const { variant, fixed, secondary, onOpen, ...rest } = props;
  const history = useHistory();
  const { isOpen, onOpen: openLogoutModal, onClose } = useDisclosure();
  const cancelRef = React.useRef();

  // Chakra Color Mode
  let navbarIcon = useColorModeValue("gray.500", "gray.200");
  let mainText = useColorModeValue("gray.700", "gray.200");
  if (secondary) {
    navbarIcon = "white";
    mainText = "white";
  }

  const handleLogout = () => {
    localStore.resetToken(); // Clear user token
    onClose(); // Close modal
    history.replace("/"); // Redirect to login
  };

  return (
    <Flex
      pe={{ sm: "0px", md: "16px" }}
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
    >
      {/* Logout Button */}
      <>
        <Button
          onClick={openLogoutModal}
          ms="0px"
          px="0px"
          me={{ sm: "2px", md: "16px" }}
          color={navbarIcon}
          variant="transparent-with-icon"
          leftIcon={
            <ProfileIcon color={navbarIcon} w="22px" h="22px" me="0px" />
          }
        >
          <Text display={{ sm: "none", md: "flex" }}>Διαχειριστής</Text>
        </Button>

        <AlertDialog
          isOpen={isOpen}
          leastDestructiveRef={cancelRef}
          onClose={onClose}
          isCentered
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                Αποσύνδεση
              </AlertDialogHeader>

              <AlertDialogBody>
                Είστε σίγουροι ότι θέλετε να αποσυνδεθείτε;
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button ref={cancelRef} onClick={onClose}>
                  Ακύρωση
                </Button>
                <Button colorScheme="red" onClick={handleLogout} ml={3}>
                  Αποσύνδεση
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </>

      {/* Sidebar */}
      <SidebarResponsive
        logoText={props.logoText}
        secondary={props.secondary}
        routes={routes}
        {...rest}
      />
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
